"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeonDappKitInvocationBuilderNeo3 = void 0;
class NeonDappKitInvocationBuilderNeo3 {
    static getReservesContractInvocation({ routerScriptHash, tokenToReceiveHash, tokenToUseHash, }) {
        return {
            scriptHash: routerScriptHash,
            operation: 'getReserves',
            args: [
                {
                    type: 'Hash160',
                    value: tokenToReceiveHash,
                },
                {
                    type: 'Hash160',
                    value: tokenToUseHash,
                },
            ],
        };
    }
    static swapTokenOutForTokenInContractInvocation({ routerScriptHash, senderAddress, amountToReceive, maximumSelling, deadline, args, }) {
        return {
            scriptHash: routerScriptHash,
            operation: 'swapTokenOutForTokenIn',
            args: [
                {
                    type: 'Hash160',
                    value: senderAddress,
                },
                {
                    type: 'Integer',
                    value: amountToReceive,
                },
                {
                    type: 'Integer',
                    value: maximumSelling,
                },
                {
                    type: 'Array',
                    value: args,
                },
                {
                    type: 'Integer',
                    value: deadline,
                },
            ],
        };
    }
    static swapTokenInForTokenOutContractInvocation({ routerScriptHash, senderAddress, amountToUse, minimumReceived, deadline, args, }) {
        return {
            scriptHash: routerScriptHash,
            operation: 'swapTokenInForTokenOut',
            args: [
                {
                    type: 'Hash160',
                    value: senderAddress,
                },
                {
                    type: 'Integer',
                    value: amountToUse,
                },
                {
                    type: 'Integer',
                    value: minimumReceived,
                },
                {
                    type: 'Array',
                    value: args,
                },
                {
                    type: 'Integer',
                    value: deadline,
                },
            ],
        };
    }
    static transferContractInvocation({ contractHash, senderAddress, tokenHash, amount, }) {
        return {
            scriptHash: contractHash,
            operation: 'transfer',
            args: [
                {
                    type: 'Hash160',
                    value: senderAddress,
                },
                {
                    type: 'Hash160',
                    value: tokenHash,
                },
                {
                    type: 'Integer',
                    value: amount,
                },
                {
                    type: 'Any',
                    value: null,
                },
            ],
        };
    }
}
exports.NeonDappKitInvocationBuilderNeo3 = NeonDappKitInvocationBuilderNeo3;
